import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../redux/hooks";
import { Navigate } from "react-router-dom";
import {
  setAuthState,
  selectIsAuthenticated,
} from "../redux/slices/auth.slice";
import { getUser } from "@/redux/user/user.action";
import { CircularProgress, Box } from "@mui/material";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        await dispatch(getUser()).unwrap();
        dispatch(setAuthState({ isAuthenticated: true }));
      } catch (err) {
        dispatch(setAuthState({ isAuthenticated: false }));
      } finally {
        setIsChecking(false);
      }
    };

    checkSession();
  }, [dispatch]);

  if (isChecking) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <CircularProgress size={30} />
        <span style={{ fontSize: "14px", color: "#666" }}>
          Verificando sesión...
        </span>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export { ProtectedRoute };
